import style from './HeaderRight.module.css'
import { useAppSelector } from '../../hooks/redux'
import { Colors } from '../../constants/Colors'

interface Props {
    icon: string | null,
    title: string | null
}

const HeaderRight = ({
        icon,
        title
    }: Props
) => {
    
    const theme = useAppSelector<string>(state => state.theme.theme)

    return (
        <div
            className={style.container}
            style={{
                backgroundColor: Colors[theme].app
            }}
        >
            <h1
                className={style.title}
                style={{
                    cursor: "pointer",
                    color: Colors[theme].activeTint,
                    transition: "all 0.2s"
                }}
            >
                {icon
                    ? <i className={icon}></i>
                    : null
                } {title
                    ? title
                    : null
                }
            </h1>
        </div>
    )
}

export default HeaderRight
